/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import MsDyn365 from '@msdyn365-commerce/core';
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { ICittaProductAttributeLinkData } from './citta-product-attribute-link.data';
import { ICittaProductAttributeLinkProps } from './citta-product-attribute-link.props.autogenerated';

export interface ICitttaProductAttributeLinkViewProps extends ICittaProductAttributeLinkProps<ICittaProductAttributeLinkData>      {
  linkItem?: INodeProps;
  className?: string;
  contentBlockContainer: IModuleProps;
}
/**
 *
 * ContentCard component
 * @extends {React.PureComponent<ICittaProductAttributeLinkProps<ICittaProductAttributeLinkData>>}
 */

class CittaProductAttributeLink extends React.PureComponent<ICittaProductAttributeLinkProps<ICittaProductAttributeLinkData>> {
  
  public render(): JSX.Element | null {
     const {
      className
    } = this.props.config;

    const content: ICittaProductAttributeLinkData = this.props.data;

    const attributes = content.attributes.result;
    const linkAttribute = attributes?.find(attribute => attribute.Name === this.props.resources.attributeName);

    if (!linkAttribute || !linkAttribute.TextValue) {
      return null;
    }
     
    const contentBlockviewProps = {
      ...this.props,
      linkItem: this._renderLink(linkAttribute.TextValue),
      contentBlockContainer: {
        moduleProps: this.props,
        className: classnames('product-attribute-link', className),
      }
    };
    return this.props.renderView(contentBlockviewProps) as React.ReactElement;
  }

  private _renderLink = (linkUrl: String) => {
    const {
      linkText
    } = this.props.config;
    return <a role='button' className="product-attribute-link__link" onClick={() => this._goToLink(linkUrl)}>{linkText || 'Discover more'}</a>
  };

  private _goToLink = (linkUrl: String) => {
    if (MsDyn365.isBrowser && typeof window !== 'undefined') {
      const baseUrl = window.location.origin;
      if (baseUrl.length) {
        window.location.assign(`${baseUrl}${linkUrl}`);
      }
    }
  }
}

export default CittaProductAttributeLink;
